import React, {FC, useEffect, useState} from "react";
import {ComboList} from "./OptionsOppComponent";
import GatewayService from "../../service/GatewayService";
import {CheckboxComponent} from "../util/CheckboxComponent";
import AppConstants from "../../util/AppConstants";
import AppUtil from "../../util/AppUtil";
import {SqueezeSell} from "../../models/Squeeze";
import TickManager from "../../service/TickManager";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import { useChain } from "../../context/ChainContext";
import {Combo} from "../../models/Combo";

interface Props {
}
const SqueezeComp:FC<Props> = (props) => {

    const [sqSell, setSqSell] = useState<Array<SqueezeSell>>([]);
    const [client,setClient] = useState("ECA007")
    const { chain, setChain } = useChain();
    const [sorter,setSorter] = useState(()=>AppUtil.genericSorterFun("squeeze", (a:SqueezeSell)=>1))

    useEffect(()=>{
        refresh()
    },[props])
    function refresh() {
        GatewayService.squeezer(client)
            .then(it=>it.sort((b,a)=>a.sellPrice*a.multiplier - b.sellPrice*b.multiplier))
            .then(setSqSell)
    }

    function getItems() {
        return sqSell
            .filter(it=>chain==="" || TickManager.getOption(it.symbol).genInfo.name===chain)
            .sort(sorter)
    }

    return<>
        <button onClick={()=>refresh()}>refresh</button>
        <div className={"tab"}>chain = <input type="text" value={chain} onChange={event => setChain(event.target.value)}/></div>
        <DropDownCompString text={"select client"} actual={client} arr={getKeyVal(["ECA007", "JHJ926"])} set={setClient}/>


        <table>
            <thead>
                <tr>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("symbol"))}>symbol</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("qty"))}>qty</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("days"))}>days</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("isSquareOff"))}>isSquareOff</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("sellPrice"))}>sellPrice</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("intrinsicValue"))}>intrinsicValue</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("extrinsicValue"))}>extrinsicValue</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("multiplier"))}>multiplier</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("margin"))}>margin</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("charges"))}>charges</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("profit"))}>profit</th>
                    <th onClick={()=>setSorter(AppUtil.genericSorterWrapper("percentPerDay"))}>percentPerDay</th>
                </tr>
            </thead>
            <tbody>
            {getItems().map(it => {
                    it.profit = (it.sellPrice- it.intrinsicValue)*it.multiplier*it.qty - it.charges
                    it.percentPerDay = it.profit/it.margin/(it.days+1)*100
                    return <tr>
                        <td>{it.symbol}</td>
                        <td>{it.qty}</td>
                        <td>{it.days}</td>
                        <td>{it.isSquareOff+""}</td>
                        <td>{it.sellPrice}</td>
                        <td>{it.intrinsicValue}</td>
                        <td>{it.extrinsicValue}</td>
                        <td>{it.multiplier}</td>
                        <td>{AppUtil.getRoundedOff(it.margin)}</td>
                        <td>{AppUtil.getRoundedOff(it.charges)}</td>
                        <td>{AppUtil.getRoundedOff(it.profit)}</td>
                        <td>{it.percentPerDay.toFixed(4)}</td>
                    </tr>
                }
                )}
            </tbody>
        </table>

    </>

}

export default SqueezeComp